$(document).ready(function($) {
    setTimeout(function() {
      $('#preloader').fadeOut('slow', function() {});
    }, 300);

    $("#menu").mmenu({
	    wrappers: ["wordpress"],
	    counters: true,
	    extensions  : [ "popup", "pagedim-black"],
	    navbar    : {
	      title     : "МЕНЮ"
	    },
	    navbars   : [{
	      position: "bottom",
	      height  : 4,
	      content : [
	        '<a href="tel:+79788401355" class="mmenu-link phone-link phone-link__mmenu" title="Позвонить в техподдержку">+7 978 840 13 55</a><br>',
	        '<a href="tel:+79788401322" class="mmenu-link phone-link phone-link__mmenu" title="Позвонить в техподдержку">+7 978 840 13 22</a>',
	      ]
	    }, {
	      content : ["prev", "title", "close" ]
	    }]
	}, {

	});

	var apiMmenu = $("#menu").data("mmenu");
	
	$(".mmenu_close").click(function(e) {
		e.preventDefault();
		apiMmenu.close();
	});

	$('#main-slider').flexslider({
		animation: "fade",
		directionNav: false,
	});

	function getGridSize() {
		return ($(window).width() < 600) ? 1 : ($(window).width() < 900) ? 2 : 3;
	}

	$('.flexslider-carusel').flexslider({
		animation: "slide",
		animationLoop: false,
		itemWidth: 290,
		itemMargin: 30,
		minItems: 1,
		maxItems: getGridSize(),
		directionNav: false,
	});

	$('#set_location').styler({});

	$('#set_location').change(function() {
		document.location.href=$(this).val();
	})

	if($('div').is('#contacts-map')){
		ymaps.ready(function () {
		  var myMap = new ymaps.Map('contacts-map', {
		          center: [44.940314, 34.051216],
		          zoom: 15,
		          controls: ['zoomControl', 'typeSelector']
		      }),
		      myPlacemark = new ymaps.Placemark([44.940314, 34.051216], {
		          iconContent: 'Red Net'
		      }, {
		          preset: "islands#dotIcon",
		          iconColor: '#0c92b5'
		      });
		  myMap.geoObjects.add(myPlacemark);
		});
	}

	$('.order_btn').magnificPopup({
    	type: 'inline',
    	removalDelay: 500, //delay removal by X to allow out-animation
    	mainClass: 'mfp-zoom-in'
	});

	$('.wpcf7-tel').mask('+7 (000) 000-00-00');
});